export default "__VITE_ASSET__BNhUggKE__"